<template>
  <div class="start-rework-dialog-rework-items">
    <div class="table-bd">
      <custom-table
        ref="table"
        type="checkbox"
        v-model="tableSelect"
        :data="reworkList"
        tableCode="start_rework_items"
        :slots="['itemName', 'action']"
        @input="onSelectionChange"
        height="100%"
        rowKey="workOrderItemId"
        @filter="filterChange"
        selectableKey="isInvalid"
      >
        <!-- 返工项 -->
        <template v-slot:itemName="scope">
          <div>
            <span>{{scope.row.itemName}}</span>
            <!-- needSn: 0不要sn  1必须 2选填 -->
            <span
              class="red"
              v-if="`${scope.row.needSn}` === '1'"
            >
              SN({{$t('asm_start_rework_dialog_rework_items.bi_tian')}})
            </span>
            <span
              class="red"
              v-if="`${scope.row.needSn}` === '2'"
            >
              SN({{$t('asm_start_rework_dialog_rework_items.xuan_tian')}})
            </span>
          </div>
        </template>
        <template v-slot:action="scope">
          <el-button
            type="text"
            size="mini"
            @click="onReplace(scope.row)"
            v-if="scope.row.newPartCount"
          >{{ $t('asm_start_rework_dialog_rework_items.geng_huan_ling_jian') }}</el-button>
        </template>
      </custom-table>
    </div>
  </div>
</template>

<script>

export default {
  name: '',
  mixins: [],
  components: {
  },
  props: {
    reworkList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      tableSelect: [],

    };
  },
  computed: {
  },
  watch: {
  },
  filters: {
  },
  directives: {
  },
  methods: {
    filterChange(e) {
      this.$emit('filterChange', e);
    },
    onReplace(row) {
      this.$emit('replace', row);
    },
    onSelectionChange(selection) {
      const itemIds = selection.map(item => item.workOrderItemId);
      this.$emit('selection', itemIds);
    },
    getTableList() {
      // workOrderItemReworkList
    },
    // ItemIds的row都选中，其他的不选中
    selectRowsByItemIds(itemIds) {
      this.reworkList.forEach((item) => {
        const value = itemIds.includes(item.workOrderItemId);
        this.$refs.table.$refs.tb1.toggleRowSelection(item, value);
      });
    },
    // id对应的row 的checkbox 状态设置为 false
    unCheckRowById(id) {
      const row = this.reworkList.find(item => item.workOrderItemId === id);
      this.$refs.table.$refs.tb1.toggleRowSelection(row, false);
    },
    checkRowById(id, value = true) {
      const row = this.reworkList.find(item => item.workOrderItemId === id);
      this.$refs.table.$refs.tb1.toggleRowSelection(row, value);
    }
  },
  created() {
  },
  mounted() {
  },
};
</script>

<style lang="scss">
.start-rework-dialog-rework-items {
  padding-top: 24px;
  height: 500px;
  display: flex;
  flex-direction: column;

  .red {
    color: #ff5c5b;
  }

  // 禁用全选
  .el-table__fixed-header-wrapper {
    .el-checkbox {
      display: none;
    }
  }
}
</style>
